import * as Sentry from '@sentry/vue';

export default {
    init: (config) => {
        Sentry.init({
            app: config.app,
            beforeSend(event) {
                // Add a tag for PWA if the app is running as a PWA
                if (window.App.isIosPwa) {
                    event.tags = event.tags || {};
                    event.tags.pwa = 'true';
                }

                // Filter out expected AbortErrors from user navigation and page lifecycle
                if (
                    event.exception?.values?.[0]?.type === 'AbortError' ||
                    event.exception?.values?.[0]?.value?.includes('operation was aborted')
                ) {
                    // Only report unexpected AbortErrors
                    const isUserNavigation =
                        document.visibilityState === 'hidden' ||
                        window.performance?.navigation?.type === 1 ||
                        event.tags?.reason === 'navigation' ||
                        event.tags?.reason === 'background';

                    if (isUserNavigation) {
                        return null; // Don't send expected AbortErrors to Sentry
                    }

                    // Mark unexpected AbortErrors for easier filtering
                    event.tags = event.tags || {};
                    event.tags.unexpected_abort = 'true';
                }

                return event;
            },
            dsn: config.dsn,
            environment: config.environment,
            release: config.release,
            ignoreErrors: [
                'NetworkError',
                'Network Error',
                'Non-Error promise rejection captured',
                'Load failed',
                'Adding tracking Ips event failed',
                'timeout',
                '<unknown>',
            ],
            denyUrls: ['wistia.com'],
        });

        Sentry.configureScope((scope) => {
            scope.setTag('transaction_id', Math.random().toString(36).substring(2, 12));
        });
    },
    captureMessage: (payload) => {
        Sentry.captureMessage(payload);
    },
    captureException: (exception, payload) => {
        Sentry.captureException(exception, payload);
    },
    captureEvent: (payload) => {
        Sentry.captureEvent(payload);
    },
    configureScope: (payload) => {
        Sentry.configureScope(payload);
    },
    addBreadcrumb: (payload) => {
        Sentry.addBreadcrumb(payload);
    },
    addCheckoutBreadcrumb(payload) {
        this.addBreadcrumb(Object.assign({ category: 'Checkout' }, payload));
    },
    setUser: (payload) => {
        Sentry.setUser(payload);
    },
    getScope() {
        let scopeData;
        Sentry.withScope((scope) => (scopeData = scope));
        return scopeData;
    },
    getTransactionId() {
        return this.getScope()?._tags?.transaction_id;
    },
};
